/* EYESHELLS 1766 — shared hero runtime, loaded once per document. */
(function(w,d){
  if(w.ESHeroSlidesV1766){ w.ESHeroSlidesV1766(); return; }
  function bindSection($,sectionId){


  function getRoot(){
    return document.querySelector('[data-section-id="' + sectionId + '"]') || document.getElementById('shopify-section-' + sectionId);
  }

  function getSlider(){
    var r = getRoot();
    if(!r) return null;
    return r.querySelector('.js-slideshow-v1') || r.querySelector('.slick-side-h1');
  }

  var MOBILE_MEDIA = null;
  try{ MOBILE_MEDIA = window.matchMedia ? window.matchMedia('(max-width: 991.98px)') : null; }catch(e){}

  function prefersReducedMotion(){
    try{ return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
    catch(e){ return false; }
  }

  function connectionAllowsWarmup(){
    try{
      var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if(!c) return true;
      if(c.saveData) return false;
      return c.effectiveType !== 'slow-2g' && c.effectiveType !== '2g';
    }catch(e){ return true; }
  }

  function toArray(nodes){
    return Array.prototype.slice.call(nodes || []);
  }

  function getSlideByIndex(index){
    var sl = getSlider();
    if(!sl) return null;
    var selector = '.slick-slide[data-slick-index="' + index + '"]:not(.slick-cloned)';
    var slide = sl.querySelector(selector);
    if(slide) return slide;
    return sl.querySelector('.itemv-slide-h1[data-es-slide-index="' + index + '"]');
  }

  function getActiveSlide(){
    var sl = getSlider();
    if(!sl) return null;
    return sl.querySelector('.slick-slide.slick-active') ||
      sl.querySelector('.itemv-slide-h1.es-editor-active') ||
      sl.querySelector('.itemv-slide-h1');
  }

  function getCurrentIndex(){
    var sl = getSlider();
    if(!sl) return 0;
    try{
      if(window.jQuery && window.jQuery.fn && window.jQuery.fn.slick && window.jQuery(sl).hasClass('slick-initialized')){
        var current = window.jQuery(sl).slick('slickCurrentSlide');
        if(typeof current === 'number' && !isNaN(current)) return current;
      }
    }catch(e){}
    var active = getActiveSlide();
    var raw = active && (active.getAttribute('data-slick-index') || active.getAttribute('data-es-slide-index'));
    var parsed = parseInt(raw, 10);
    return isNaN(parsed) ? 0 : parsed;
  }

  function getSlideCount(){
    var sl = getSlider();
    if(!sl) return 0;
    return sl.querySelectorAll('.itemv-slide-h1:not(.slick-cloned)').length;
  }

  function markWrapLoading(media){
    var wrap = media && media.closest ? media.closest('.es-hero-video-wrap') : null;
    if(wrap){
      wrap.classList.remove('is-ready', 'is-error');
      wrap.classList.add('is-loading');
    }
  }

  function markWrapError(media){
    var wrap = media && media.closest ? media.closest('.es-hero-video-wrap') : null;
    if(wrap){
      wrap.classList.remove('is-loading');
      wrap.classList.add('is-error');
    }
  }

  function bindVideoState(video){
    if(!video || video.getAttribute('data-es-state-bound') === '1') return;
    video.setAttribute('data-es-state-bound', '1');
    var ready = function(){
      var wrap = video.closest('.es-hero-video-wrap');
      if(wrap){
        wrap.classList.remove('is-loading', 'is-error');
        wrap.classList.add('is-ready');
      }
    };
    video.addEventListener('loadeddata', ready, { passive:true });
    video.addEventListener('canplay', ready, { passive:true });
    video.addEventListener('playing', ready, { passive:true });
    video.addEventListener('error', function(){ markWrapError(video); }, { passive:true });
  }

  function chooseVideoSource(video){
    if(!video) return { src:'', type:'' };
    var mobile = !!(MOBILE_MEDIA && MOBILE_MEDIA.matches);
    if(mobile && video.getAttribute('data-es-video-mobile-src')){
      return {
        src:video.getAttribute('data-es-video-mobile-src'),
        type:video.getAttribute('data-es-video-mobile-type') || ''
      };
    }
    return {
      src:video.getAttribute('data-es-video-src') || '',
      type:video.getAttribute('data-es-video-type') || ''
    };
  }

  function ensureVideoLoaded(video, warmOnly){
    if(!video) return false;
    bindVideoState(video);
    var selected = chooseVideoSource(video);
    if(!selected.src) return false;
    if(video.getAttribute('data-es-loaded-src') === selected.src){
      if(!warmOnly) video.preload = 'auto';
      return true;
    }

    markWrapLoading(video);
    try{
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.preload = warmOnly ? 'metadata' : 'auto';
      video.removeAttribute('src');
      toArray(video.querySelectorAll('source[data-es-runtime-source]')).forEach(function(source){
        source.parentNode.removeChild(source);
      });
      var source = document.createElement('source');
      source.setAttribute('data-es-runtime-source', '1');
      // A failing <source> does not reliably emit an error on its <video> parent.
      source.addEventListener('error', function(){ markWrapError(video); }, { once:true });
      source.src = selected.src;
      if(selected.type) source.type = selected.type;
      video.appendChild(source);
      video.setAttribute('data-es-loaded-src', selected.src);
      video.load();
      return true;
    }catch(e){
      markWrapError(video);
      return false;
    }
  }

  function ensureIframeLoaded(frame){
    if(!frame) return false;
    var src = frame.getAttribute('data-es-video-src');
    if(!src || frame.getAttribute('src')) return !!frame.getAttribute('src');
    markWrapLoading(frame);
    frame.addEventListener('load', function(){
      var wrap = frame.closest('.es-hero-video-wrap');
      if(wrap){
        wrap.classList.remove('is-loading', 'is-error');
        wrap.classList.add('is-ready');
      }
    }, { once:true });
    frame.addEventListener('error', function(){ markWrapError(frame); }, { once:true });
    frame.setAttribute('src', src);
    return true;
  }

  function ensureSlideLoaded(slide, warmOnly){
    if(!slide) return;
    toArray(slide.querySelectorAll('video.es-hero-video-tag')).forEach(function(video){
      ensureVideoLoaded(video, warmOnly);
    });
    if(!warmOnly){
      toArray(slide.querySelectorAll('iframe[data-es-video-src]')).forEach(ensureIframeLoaded);
    }
  }

  function sendFrameCommand(frame, command){
    if(!frame || !frame.contentWindow) return;
    try{
      frame.contentWindow.postMessage(JSON.stringify({ event:'command', func:command, args:[] }), '*');
      frame.contentWindow.postMessage({ method:command === 'playVideo' ? 'play' : 'pause' }, '*');
    }catch(e){}
  }

  function pauseAll(exceptSlide){
    var r = getRoot();
    if(!r) return;
    toArray(r.querySelectorAll('video.es-hero-video-tag')).forEach(function(video){
      if(exceptSlide && exceptSlide.contains(video)) return;
      try{ video.pause(); }catch(e){}
    });
    toArray(r.querySelectorAll('iframe.es-hero-video, iframe[data-es-deferred-iframe]')).forEach(function(frame){
      if(exceptSlide && exceptSlide.contains(frame)) return;
      sendFrameCommand(frame, 'pauseVideo');
    });
  }

  var heroInViewport = true;

  function playActive(){
    var active = getActiveSlide();
    if(!active) return;
    ensureSlideLoaded(active, false);
    pauseAll(active);

    if(!heroInViewport || document.hidden) return;

    var reduce = prefersReducedMotion();
    toArray(active.querySelectorAll('video.es-hero-video-tag')).forEach(function(video){
      try{ video.muted = true; }catch(e){}
      if(reduce){
        try{ video.pause(); }catch(e){}
        return;
      }
      try{
        var promise = video.play();
        if(promise && typeof promise.catch === 'function') promise.catch(function(){});
      }catch(e){}
    });
    if(!reduce){
      toArray(active.querySelectorAll('iframe.es-hero-video, iframe[data-es-deferred-iframe]')).forEach(function(frame){
        sendFrameCommand(frame, 'playVideo');
      });
    }
  }

  function findNextVideoSlide(fromIndex, direction){
    var count = getSlideCount();
    if(!count) return null;
    var dir = direction < 0 ? -1 : 1;
    for(var step = 1; step <= count; step++){
      var idx = (fromIndex + (step * dir) + count) % count;
      var slide = getSlideByIndex(idx);
      if(!slide || slide.getAttribute('data-es-video-slide') !== '1') continue;
      var unloaded = slide.querySelector('video.es-hero-video-tag:not([data-es-loaded-src])');
      if(unloaded) return slide;
    }
    return null;
  }

  var warmToken = 0;
  function scheduleNextWarmup(index, delay){
    if(prefersReducedMotion() || !connectionAllowsWarmup()) return;
    var token = ++warmToken;
    var run = function(){
      if(token !== warmToken || document.hidden) return;
      var slide = findNextVideoSlide(index, 1);
      if(slide) ensureSlideLoaded(slide, true);
    };
    var idle = function(){
      if('requestIdleCallback' in window){
        window.requestIdleCallback(run, { timeout:2500 });
      }else{
        window.setTimeout(run, delay || 900);
      }
    };
    if(document.readyState === 'complete') idle();
    else window.addEventListener('load', idle, { once:true, passive:true });
  }

  function warmTargetFromControl(target){
    var sl = getSlider();
    if(!sl || !target) return;
    var current = getCurrentIndex();
    var targetSlide = null;
    if(target.closest && target.closest('.next-slide')) targetSlide = findNextVideoSlide(current, 1);
    else if(target.closest && target.closest('.prev-slide')) targetSlide = findNextVideoSlide(current, -1);
    else{
      var dot = target.closest && target.closest('.slick-dots li');
      if(dot && dot.parentNode){
        var dots = toArray(dot.parentNode.children);
        var idx = dots.indexOf(dot);
        if(idx >= 0) targetSlide = getSlideByIndex(idx);
      }
    }
    if(targetSlide) ensureSlideLoaded(targetSlide, true);
  }

  function bindIntentWarmup(slider){
    if(!slider || slider.getAttribute('data-es-intent-bound') === '1') return;
    slider.setAttribute('data-es-intent-bound', '1');
    ['pointerover','focusin','touchstart'].forEach(function(type){
      slider.addEventListener(type, function(evt){ warmTargetFromControl(evt.target); }, { passive:true });
    });
  }

  function bindSlickHooks(){
    var sl = getSlider();
    if(!sl || !window.jQuery || !window.jQuery(sl).on) return;

    var $s = window.jQuery(sl);
    if($s.data('esV1VideoHooks')){
      playActive();
      return;
    }
    $s.data('esV1VideoHooks', 1);
    bindIntentWarmup(sl);

    $s.on('init.esV1Video reInit.esV1Video', function(){
      playActive();
      scheduleNextWarmup(getCurrentIndex(), 1000);
    });
    $s.on('beforeChange.esV1Video', function(evt, slick, current, next){
      pauseAll();
      ensureSlideLoaded(getSlideByIndex(next), false);
    });
    $s.on('afterChange.esV1Video', function(evt, slick, current){
      playActive();
      scheduleNextWarmup(typeof current === 'number' ? current : getCurrentIndex(), 700);
    });

    playActive();
    scheduleNextWarmup(getCurrentIndex(), 1100);
  }

  function bindVisibilityLifecycle(){
    var root = getRoot();
    if(!root || root.getAttribute('data-es-video-visibility-bound') === '1') return;
    root.setAttribute('data-es-video-visibility-bound', '1');

    if('IntersectionObserver' in window){
      var observer = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          heroInViewport = !!entry.isIntersecting;
          if(heroInViewport) playActive();
          else pauseAll();
        });
      }, { threshold:0.01 });
      observer.observe(root);
    }

    document.addEventListener('visibilitychange', function(){
      if(document.hidden) pauseAll();
      else if(heroInViewport) playActive();
    }, { passive:true });
  }

  // Bind before or after Slick initializes; both paths are supported.
  bindSlickHooks();
  bindVisibilityLifecycle();
  setTimeout(bindSlickHooks, 120);
  setTimeout(bindSlickHooks, 700);

  // --- Theme Editor: scheme 2 (select block -> go to that slide) ---
  function getAnchorByBlockId(blockId){
    var r = getRoot();
    if(!r || !blockId) return null;
    return r.querySelector('.es-editor-anchor[data-es-block-id="' + blockId + '"]');
  }

  function getSlideIndexByBlockId(blockId){
    var a = getAnchorByBlockId(blockId);
    if(a){
      var idx = parseInt(a.getAttribute('data-es-slide-index'), 10);
      if(!isNaN(idx)) return idx;
    }
    return null;
  }

  function setPreinitActive(blockId){
    var sl = getSlider();
    if(!sl) return;
    if(sl.classList && sl.classList.contains('slick-initialized')) return;

    var slides = sl.querySelectorAll('.itemv-slide-h1');
    if(!slides || !slides.length) return;

    for(var i=0;i<slides.length;i++){
      slides[i].classList && slides[i].classList.remove('es-editor-active');
    }

    var target = null;
    if(blockId){
      var idx = getSlideIndexByBlockId(blockId);
      if(idx !== null && slides[idx]) target = slides[idx];

      if(!target){
        for(var j=0;j<slides.length;j++){
          if(slides[j].getAttribute && slides[j].getAttribute('data-es-block-id') === blockId){
            target = slides[j];
            break;
          }
        }
      }
    }

    if(!target) target = slides[0];
    if(target && target.classList) target.classList.add('es-editor-active');
  }

  function slickGoTo(sl, idx){
    if(!sl || typeof idx !== 'number' || idx < 0) return false;
    if(!window.jQuery) return false;

    var $s = window.jQuery(sl);
    if(!$s.hasClass('slick-initialized')) return false;

    try{
      $s.slick('slickGoTo', idx, true);
      try{ $s.slick('setPosition'); }catch(e){}
      setTimeout(function(){ playActive(); }, 60);
      return true;
    } catch(e){
      return false;
    }
  }

  function resolveIndexFromSlick(sl, blockId){
    if(!window.jQuery) return null;
    try{
      var $s = window.jQuery(sl);
      if(!$s.hasClass('slick-initialized')) return null;
      var slick = $s.slick('getSlick');
      if(slick && slick.$slides){
        var found = null;
        slick.$slides.each(function(i, el){
          if(el && el.getAttribute && el.getAttribute('data-es-block-id') === blockId){
            found = i;
            return false;
          }
        });
        return found;
      }
    } catch(e){}
    return null;
  }

  function goToBlock(blockId){
    if(!blockId) return;

    // Immediate feedback even when Slick isn't ready
    try{ setPreinitActive(blockId); }catch(e){}

    var sl = getSlider();
    if(!sl) return;

    // If slick is ready, go now
    if(window.jQuery && window.jQuery(sl).hasClass('slick-initialized')){
      var idxNow = getSlideIndexByBlockId(blockId);
      if(idxNow === null) idxNow = resolveIndexFromSlick(sl, blockId);
      if(typeof idxNow === 'number') slickGoTo(sl, idxNow);
      return;
    }

    // Slick not ready yet -> poll for init (editor only)
    if(window.Shopify && Shopify.designMode){
      var attempts = 0;
      (function wait(){
        attempts++;
        var sl2 = getSlider();
        if(!sl2) return;

        if(window.jQuery && window.jQuery(sl2).hasClass('slick-initialized')){
          var idx2 = getSlideIndexByBlockId(blockId);
          if(idx2 === null) idx2 = resolveIndexFromSlick(sl2, blockId);
          if(typeof idx2 === 'number') slickGoTo(sl2, idx2);
          return;
        }

        if(attempts < 30) setTimeout(wait, 120);
      })();
    }
  }

  if(window.Shopify && Shopify.designMode){
    window.__esSlideshowV1Editor = window.__esSlideshowV1Editor || {};
    if(!window.__esSlideshowV1Editor[sectionId]){
      window.__esSlideshowV1Editor[sectionId] = true;

      // Ensure first slide is visible before Slick initializes
      try{ setPreinitActive(); }catch(e){}

      var lastBlockId = null;

      function onBlockSelect(evt){
        var d = evt && evt.detail;
        if(!d) return;

        var blockId = d.blockId || d.block_id;
        if(!blockId) return;

        // Only react if the selected block belongs to THIS slideshow section.
        var r = getRoot();
        if(!r) return;
        if(!r.querySelector('.es-editor-anchor[data-es-block-id=\"' + blockId + '\"]')) return;

        lastBlockId = blockId;

        // Prevent the editor from "auto scrolling" around on first selection.
        var y = window.pageYOffset || document.documentElement.scrollTop || 0;

        // Try immediately and again shortly after (covers late Slick init).
        goToBlock(blockId);
        setTimeout(function(){ goToBlock(blockId); }, 140);
        setTimeout(function(){ try{ window.scrollTo(0, y); }catch(e){} }, 0);
      }

      function onSectionRefresh(){
        // In the Theme Editor, Shopify often replaces the whole section DOM.
        // Don't trust sectionId values in events; just re-bind if our root exists.
        var r = getRoot();
        if(!r) return;

        setTimeout(function(){
          bindSlickHooks();
          setPreinitActive(lastBlockId || null);
          if(lastBlockId) goToBlock(lastBlockId);
          playActive();
        }, 220);
      }

      // Some editor events fire on window, some on document (depends on Shopify Editor version)
      document.addEventListener('shopify:block:select', onBlockSelect);
      window.addEventListener('shopify:block:select', onBlockSelect);

      document.addEventListener('shopify:section:load', onSectionRefresh);
      window.addEventListener('shopify:section:load', onSectionRefresh);
      document.addEventListener('shopify:section:select', onSectionRefresh);
      window.addEventListener('shopify:section:select', onSectionRefresh);

    }
  }

  // Pause videos when hero is offscreen (performance)
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(!entry.isIntersecting){
          pauseAll();
        } else {
          playActive();
        }
      });
    }, { threshold: 0.2 });

    var r0 = getRoot();
    if(r0) io.observe(r0);
  }

  }
  function init(){
    if(typeof w.ES_jqReady !== 'function') return;
    w.ES_jqReady(function($){
      d.querySelectorAll('[data-section-type="section-slideshow-v1"]').forEach(function(root){
        if(root.getAttribute('data-es-hero-runtime')==='1766') return;
        var id=root.getAttribute('data-section-id');
        if(!id) return;
        root.setAttribute('data-es-hero-runtime','1766');
        bindSection($,id);
      });
    });
  }
  w.ESHeroSlidesV1766=init;
  d.addEventListener('shopify:section:load',init);
  init();
})(window,document);
